/**
 * ユーザ情報
 */
export class UserInfo {
    /** ユーザーID */
    userId = ""

    /** 名前 */
    userName = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<UserInfo>) {
        Object.assign(this, init)
    }
}
